import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { MobileTopicSection } from "@outschool/ui-components-website";
import React, { useMemo } from "react";

const MAX_RELATED_CATEGORIES_NUM = 5;

type Category = NonNullable<
  NonNullable<
    ClassDetailsNoSectionsQuery["activity"]["relatedCategories"]
  >[number]
>;

type Props = {
  activity: ClassDetailsNoSectionsQuery["activity"];
};

export const RelatedCategories = ({ activity }: Props) => {
  const { t } = useTranslation(
    "client\\components\\detailPage\\mobileBelowClassDetail",
  );

  const relatedCategoriesTopics = useMemo(() => {
    const categories = activity.relatedCategories;

    return categories
      ?.filter((category): category is Category => !!category)
      .map(({ nameTitleCased, ...rest }) => ({
        title: nameTitleCased,
        ...rest,
      }));
  }, [activity.relatedCategories]);

  return (
    <>
      {!!relatedCategoriesTopics?.length && (
        <MobileTopicSection
          title={t("Related categories")}
          topics={relatedCategoriesTopics}
          maxTopicsNum={MAX_RELATED_CATEGORIES_NUM}
        />
      )}
    </>
  );
};
